/**
 * Nutrition Formatter
 * Automatically formats raw nutrition text into a clean table
 */

(function() {
  'use strict';

  // Display labels — bridged from Liquid via window.SC_NUTRITION_LABELS for localization.
  // The regex keys below stay in Danish because product source data is Danish.
  var L = (typeof window !== 'undefined' && window.SC_NUTRITION_LABELS) || {};
  var DISPLAY_LABELS = {
    'Energi': L.energy || 'Energi',
    'Fedt': L.fat || 'Fedt',
    'Heraf mættede fedtsyrer': L.saturated_fat || '- mættede fedtsyrer',
    'Kulhydrat': L.carbohydrate || 'Kulhydrat',
    'Heraf sukkerarter': L.sugars || '- sukkerarter',
    'Protein': L.protein || 'Protein',
    'Salt': L.salt || 'Salt',
    'Fiber': L.fiber || 'Fiber'
  };

  // Patterns to match nutrition data
  const nutritionPatterns = [
    { key: 'Energi', unit: 'kJ', isMain: true },
    { key: 'Energi', unit: 'kcal', isMain: true, skipIfPreviousExists: true },
    { key: 'Fedt', unit: 'g', isMain: true },
    { key: 'Heraf mættede fedtsyrer', unit: 'g', isSub: true },
    { key: 'Kulhydrat', unit: 'g', isMain: true },
    { key: 'Heraf sukkerarter', unit: 'g', isSub: true },
    { key: 'Protein', unit: 'g', isMain: true },
    { key: 'Salt', unit: 'g', isMain: true },
    { key: 'Fiber', unit: 'g', isMain: true }
  ];

  function parseNutritionText(text) {
    const results = [];
    let disclaimer = '';

    // Clean the text
    const cleanText = text.replace(/\s+/g, ' ').trim();

    // Extract disclaimer if present
    const disclaimerMatch = cleanText.match(/Vi opdaterer.+$/i);
    if (disclaimerMatch) {
      disclaimer = disclaimerMatch[0];
    }

    // Try to extract each nutrition value
    for (const pattern of nutritionPatterns) {
      // Create regex to match "Key: Value unit" or "KeyValue unit"
      const regexWithColon = new RegExp(pattern.key + '\\s*:\\s*([\\d.,]+)\\s*' + pattern.unit, 'i');
      const regexWithoutColon = new RegExp(pattern.key + '\\s*([\\d.,]+)\\s*' + pattern.unit, 'i');

      let match = cleanText.match(regexWithColon) || cleanText.match(regexWithoutColon);

      if (match) {
        // Skip if this is a duplicate energy value
        if (pattern.skipIfPreviousExists && results.some(r => r.key === 'Energi')) {
          // Append to existing energy
          const energyItem = results.find(r => r.key === 'Energi');
          if (energyItem && pattern.unit === 'kcal') {
            energyItem.value += ' / ' + match[1] + ' ' + pattern.unit;
          }
          continue;
        }

        results.push({
          key: pattern.key,
          value: match[1] + ' ' + pattern.unit,
          isSub: pattern.isSub || false
        });
      }
    }

    return { items: results, disclaimer };
  }

  function createNutritionTable(data) {
    if (data.items.length === 0) {
      return null;
    }

    const table = document.createElement('table');
    table.className = 'nutrition-table';

    const tbody = document.createElement('tbody');

    for (const item of data.items) {
      const tr = document.createElement('tr');
      if (item.isSub) {
        tr.className = 'sub';
      }

      const th = document.createElement('th');
      th.textContent = DISPLAY_LABELS[item.key] || (item.isSub ? item.key.replace('Heraf ', '') : item.key);

      const td = document.createElement('td');
      td.textContent = item.value;

      tr.appendChild(th);
      tr.appendChild(td);
      tbody.appendChild(tr);
    }

    // Column basis header - states that every figure below is per 100 g.
    // Falls back to Danish if a theme's locale files lack the key.
    var basis = L.per_100g;
    if (!basis || basis.indexOf('Translation missing') !== -1) { basis = 'pr. 100 g'; }

    const thead = document.createElement('thead');
    const headRow = document.createElement('tr');
    headRow.className = 'nutrition-table__head';

    const headSpacer = document.createElement('th');
    headSpacer.setAttribute('scope', 'col');

    const headBasis = document.createElement('th');
    headBasis.setAttribute('scope', 'col');
    headBasis.className = 'nutrition-table__basis';
    headBasis.textContent = basis;

    headRow.appendChild(headSpacer);
    headRow.appendChild(headBasis);
    thead.appendChild(headRow);
    table.appendChild(thead);

    table.appendChild(tbody);

    const container = document.createElement('div');
    container.className = 'nutrition-formatted';
    container.appendChild(table);

    if (data.disclaimer) {
      const note = document.createElement('p');
      note.className = 'nutrition-note';
      note.textContent = L.disclaimer || data.disclaimer;
      container.appendChild(note);
    }

    return container;
  }

  function formatNutritionContent() {
    // Find all accordion content that might contain nutrition data
    const accordionContents = document.querySelectorAll('.accordion__content.prose');

    accordionContents.forEach(content => {
      // Skip if already formatted
      if (content.querySelector('.nutrition-formatted')) {
        return;
      }

      const text = content.textContent || '';

      // Check if this looks like nutrition data
      if (text.includes('Energi') && (text.includes('kJ') || text.includes('kcal')) &&
          (text.includes('Fedt') || text.includes('Protein'))) {

        const parsed = parseNutritionText(text);

        if (parsed.items.length >= 3) {
          const table = createNutritionTable(parsed);

          if (table) {
            // Wrap existing content
            const existingContent = content.innerHTML;
            content.innerHTML = '';
            content.appendChild(table);

            // Keep original as hidden fallback
            const raw = document.createElement('div');
            raw.className = 'nutrition-raw';
            raw.innerHTML = existingContent;
            content.appendChild(raw);
          }
        }
      }
    });
  }

  // Run on page load
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', formatNutritionContent);
  } else {
    formatNutritionContent();
  }

  // Also run when accordions are opened (for lazy-loaded content)
  document.addEventListener('toggle', function(e) {
    if (e.target.matches('details')) {
      setTimeout(formatNutritionContent, 50);
    }
  }, true);
})();

